import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import styled from 'styled-components';
import { colors } from '../theme/tokens/colors';

const LogoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${colors.background.dark};
`;

const LogoutMessage = styled.div`
  color: ${colors.text.light};
  margin-top: 16px;
  font-size: 16px;
`;

const Logout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
        // Kurz warten, damit der Benutzer die Nachricht sehen kann
        setTimeout(() => {
          navigate('/login');
        }, 1500);
      } catch (error) {
        console.error('Logout failed:', error);
        navigate('/login');
      }
    };

    performLogout();
  }, [logout, navigate]);

  return (
    <LogoutContainer>
      <Spin size="large" />
      <LogoutMessage>Sie werden abgemeldet...</LogoutMessage>
    </LogoutContainer>
  );
};

export default Logout;
